import { ServerImageInfo } from '@/api/type-server'
import { ImageStoreStatus } from '@/consts/image'
import { PortProtocol } from '@/consts/machine'

export class Image {
  id = 0
  resID = ''
  alias = ''
  description = ''
  public = false
  storeStatus: ImageStoreStatus = ImageStoreStatus.Invalid
  ports: ServerImageInfo['ports']
  minResource: ServerImageInfo['minResource'] = null

  constructor(props: ServerImageInfo) {
    this.id = props.id
    this.resID = props.resID
    this.alias = props.alias
    this.description = props.description
    this.public = props.public
    this.storeStatus = props.storeStatus as ImageStoreStatus
    this.ports = props.ports || []
    this.minResource = props.minResource ?? null
  }

  get supportVnc(): boolean {
    return this.ports.findIndex((p) => p.protocol === PortProtocol.VNC) >= 0
  }
}
